import CB_LogoLinea from "./img/CB_LogoLinea_.png";
import CB_LogoRelleno from "./img/CB_LogoRelleno.png";
import CB_letras from "./img/CB-letras.png";
import berusLogo from "./img/berusLogo.png";
import camara from "./img/camara.png";
import catalogo from "./img/catalogo.png";
import character from "./img/character.png";
import chat from "./img/chat.png";
import key from "./img/key.png";
import logo from "./img/logo.png";
import settings from "./img/settings.png";
import shirt from "./img/shirt.png";
import shop from "./img/shop.png";
import user from "./img/user.png";
import LogoModales from "./img/LogoModales.png";
import Variante0 from "./img/Variante0.png";
import Variante1 from "./img/Variante1.png";
import Variante2 from "./img/Variante2.png";
import Variante3 from "./img/Variante3.png";
import Variante4 from "./img/Variante4.png";
import Variante5 from "./img/Variante5.png";
import {
  Settings as SettingsIcon,
  Person as PersonIcon,
  Camera as CameraIcon,
  ShoppingCart as ShoppingCartIcon,
  VpnKey as VpnKeyIcon,
  Checkroom as ShirtIcon,
  Chat as ChatIcon,
  Search as SearchIcon,
  Home as HomeIcon,
} from '@mui/icons-material';

const images = {
  CB_LogoLinea,
  CB_LogoRelleno,
  CB_letras,
  berusLogo,
  camara,
  catalogo,
  character,
  chat,
  key,
  logo,
  settings,
  shirt,
  shop,
  user,
  LogoModales,
  Variante0,
  Variante1,
  Variante2,
  Variante3,
  Variante4,
  Variante5,
};

export const menuItems = [
  { icon: images.settings, fallbackIcon: <SettingsIcon />, label: 'Settings' },
  { icon: images.user, fallbackIcon: <PersonIcon />, label: 'Profile' },
  { icon: images.camara, fallbackIcon: <CameraIcon />, label: 'Camera' },
  { icon: images.shop, fallbackIcon: <ShoppingCartIcon />, label: 'Shop' },
  { icon: images.key, fallbackIcon: <VpnKeyIcon />, label: 'Key' },
  { icon: images.shirt, fallbackIcon: <ShirtIcon />, label: 'Clothing' },
  { icon: images.chat, fallbackIcon: <ChatIcon />, label: 'Chat' },
  { icon: images.catalogo, fallbackIcon: <SearchIcon />, label: 'Search' },
];

export const logoItems = {
  mainLogo: images.CB_LogoRelleno,
  lineLogo: images.CB_LogoLinea,
  textLogo: images.CB_letras,
};

export default images;

